import { useCallback, useEffect, useState } from 'react';

const isStandaloneDisplay = () => {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
};

export const useInstallPrompt = (setStatus) => {
  const [installPromptEvent, setInstallPromptEvent] = useState(null);
  const [isStandalone, setIsStandalone] = useState(() => isStandaloneDisplay());

  useEffect(() => {
    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setInstallPromptEvent(event);
      if (setStatus) setStatus((prev) => prev || 'App kann installiert werden');
    };
    const handleAppInstalled = () => {
      setInstallPromptEvent(null);
      setIsStandalone(true);
      if (setStatus) setStatus('Als App installiert');
    };
    const mediaQuery = window.matchMedia('(display-mode: standalone)');
    const updateStandalone = () => setIsStandalone(mediaQuery.matches || window.navigator.standalone === true);

    updateStandalone();
    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);
    mediaQuery.addEventListener('change', updateStandalone);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
      mediaQuery.removeEventListener('change', updateStandalone);
    };
  }, [setStatus]);

  const handleInstallPwa = useCallback(async () => {
    if (!installPromptEvent) return;
    installPromptEvent.prompt();
    const { outcome } = await installPromptEvent.userChoice;
    if (setStatus) setStatus(outcome === 'accepted' ? 'Installation gestartet' : 'Installation abgebrochen');
    setInstallPromptEvent(null);
  }, [installPromptEvent, setStatus]);

  return { installPromptEvent, isStandalone, handleInstallPwa };
};
